import React, {ReactElement, ReactNode} from 'react';
import {cx} from '@emotion/css';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph from '../Text/Paragraph/Paragraph';
import {Alignment} from '../../../types';

import styles from './InformationBox.styles';

interface Props {
  title?: string | ReactNode;
  copy: string | ReactNode;
  children: ReactNode;
  align?: Alignment;
  icon?: ReactNode;
  hasBorder?: boolean;
  className?: string;
  titleClass?: string;
  copyClass?: string;
}

function InformationBox({
  title,
  copy,
  align = Alignment.CENTER,
  children,
  icon,
  hasBorder,
  className = '',
  titleClass,
  copyClass,
}: Props): ReactElement {
  return (
    <div data-testid="ui.infobox" className={cx(styles.informationBox(align, hasBorder), className)}>
      {icon}
      {title && (
        <Headers headerType={HeaderType.H2} alignment={align} className={cx(titleClass)}>
          {title}
        </Headers>
      )}
      <Paragraph className={cx(styles.copy, copyClass)} alignment={align}>
        {copy}
      </Paragraph>
      {children}
    </div>
  );
}

export default InformationBox;
